import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
    getCustomerDetails,
    parseChargeback,
    blockChargebackCustomer as blockChargebackCustomerService,
} from "../services/customerDetailsServices";
import { useSelector } from "react-redux";
import { useMemo } from "react";

const initialState = {
    customerDetailsState: {},
    customerDetailsIsLoading: false,
};

export const customerDetailsGet = createAsyncThunk(
    "customerDetailsGet",
    async (payload) => {
        return await getCustomerDetails(payload);
    }
);

export const chargebackParse = createAsyncThunk(
    "chargebackParse",
    async (payload) => {
        return await parseChargeback(payload);
    }
);

export const blockChargebackCustomer = createAsyncThunk(
    "blockChargebackCustomer",
    async (payload) => {
        return await blockChargebackCustomerService(payload);
    }
);



const customerDetailsSlice = createSlice({
    name: "customerDetailsSlice",
    initialState,
    reducers: {
        clearCustomerDetails: () => initialState,
    },
    extraReducers: (builder) => {
        builder.addCase(customerDetailsGet.pending, (state, action) => {
            state.customerDetailsIsLoading = true;
        });
        builder.addCase(customerDetailsGet.fulfilled, (state, action) => {
            state.customerDetailsIsLoading = false;
            state.customerDetailsState = action.payload;
        });
        builder.addCase(customerDetailsGet.rejected, (state, action) => {
            state.customerDetailsIsLoading = false;
        });


    },
});

export default customerDetailsSlice.reducer;
export const { clearCustomerDetails } = customerDetailsSlice.actions;

export const selectCustomerDetailsState = (state) =>
    state.customerDetails.customerDetailsState;

export const useCustomerDetailsState = () => {
    const customerDetailsState = useSelector(selectCustomerDetailsState);
    return useMemo(() => customerDetailsState, [customerDetailsState]);
};


